import { useCompetitionRegistrationCategorySummaryQuery } from '~/pages/competition/set-category/queries';
import { usePersonQuery } from '~/pages/person/queries';
import { Schema } from './register-lifter-form-schema';
import { useFormContext } from 'react-hook-form';
import { useParams } from '~/hooks/useParams';
import { Input } from '~/components/Input';
import { idParamSchema } from '~/schemas';
import { useMemo } from 'react';

export function RegisterLifterWeightClass() {
  const { formState, register, watch } = useFormContext<Schema>();
  const { id } = useParams(idParamSchema.parse);

  const { data = [], isLoading } = useCompetitionRegistrationCategorySummaryQuery(id);
  const { data: person } = usePersonQuery(watch('person_id'));

  const competitionTypeId = Number(watch('competition_type_id'));
  const competitionType = data.find(d => d.competition_type.id === competitionTypeId);

  const ageCategoryId = Number(watch('category_id'));
  const ageCategory = competitionType?.age_categories.find(d => d.age_category.id === ageCategoryId);

  const { options, isNullOnly } = useMemo(() => {
    const weightClasses = ageCategory?.weight_classes;

    const isNullOnly = weightClasses?.length === 1 && weightClasses[0] === null;

    if (isNullOnly) {
      return {
        options: [['Ingen viktklass', null]] as [string, number | null][],
        isNullOnly: true,
      };
    }

    const validWeightClasses = weightClasses?.filter((d): d is NonNullable<typeof d> => d !== null) ?? [];
    const filtered = validWeightClasses
      .filter(d => d.is_male === person?.is_male)
      .map(d => [d.name, d.id] as [string, number]);

    return {
      options: filtered,
      isNullOnly: false,
    };
  }, [ageCategory?.weight_classes, person?.is_male]);

  return (
    <Input.Select
      {...register('weight_class_id')}
      defaultValue={watch('weight_class_id') ?? undefined}
      disabled={isLoading || !ageCategoryId || !person}
      placeholder={isNullOnly ? undefined : 'Välj viktklass'}
      name="weight_class_id"
      formState={formState}
      options={options}
    />
  );
}
